export default [
  {
    path: "/app/module-restricted",
    name: "module-restricted",
    component: () => import("@common/views/ModuleRestricted.vue")
  }
];
